import React, { useCallback, useState } from "react";
import { pluck } from "ramda";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";

const authTypes = [
  { value: "region", display: "Geolocation" },
  { value: "ip", display: "IP" },
  { value: "ezproxy", display: "EzProxy" },
  { value: "referer", display: "Referer" },
  { value: "sip", display: "SIP" },
  { value: "papi", display: "Patron API" },
  { value: "barcode", display: "Barcode" },
  { value: "shibboleth", display: "Shibboleth" },
  { value: "scope", display: "Scope" },
  { value: "redemption", display: "Redeption Code" },
];

const AuthenticationTypeSelect = props => {
  const { onChange, value, label = "Authentication Type" } = props;

  const [selectedTypes, setSelectedTypes] = useState(value);

  const handleChange = useCallback(
    (_event, types) => {
      setSelectedTypes(types);
      onChange(pluck("value", types));
    },
    [onChange],
  );

  return (
    <Autocomplete
      multiple
      id="tags-standard"
      options={authTypes}
      getOptionLabel={option => option.display}
      value={selectedTypes || []}
      onChange={handleChange}
      renderInput={params => (
        <TextField
          {...params}
          variant="standard"
          label={label}
          placeholder="Select..."
        />
      )}
    />
  );
};

export default AuthenticationTypeSelect;
